import classNames from 'classnames';
import { FC } from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

import style from './link.module.scss';

interface Props extends LinkProps {
  truncate?: boolean;
  /**
   * When true, stamps `target="_blank"` and `rel="noopener noreferrer"` so the
   * link opens in a new tab and the new context can't access `window.opener`.
   * Bundling both attributes prevents accidentally shipping `target="_blank"`
   * without the security `rel` pair.
   */
  openInNewTab?: boolean;
}

const Link: FC<Props> = ({
  truncate = false,
  openInNewTab = false,
  children,
  className,
  ...rest
}) => {
  return (
    <RouterLink
      className={classNames(className, style.link, {
        [style.truncate]: truncate,
      })}
      {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
      {...rest}
    >
      {children}
    </RouterLink>
  );
};

const PlainLink = (
  props: React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    className?: string;
    truncate?: boolean;
    openInNewTab?: boolean;
  }
) => {
  const { openInNewTab, ...rest } = props;
  return (
    <a
      {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
      {...rest}
      className={classNames(props.className, style.link, {
        [style.truncate]: props.truncate,
      })}
    />
  );
};

export { Link, PlainLink };
